<template>
    <div id="comment_type_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="reasonHeader" v-if="$route.params.id > 0">Update Subject</span>
                    <span class="page-title" id="reasonHeader" v-else>Add Subject</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackSubjectList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container metric-form" id="SubjectForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Module:</label>
                                        <v-select v-model="modules" placeholder="Select Module."
                                                label="text"
                                                :options="moduleArr">
                                        </v-select>
                                        <div class="field-error">{{module_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Type:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateSubjectBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateSubject" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateSubjectBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateSubject"> 
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueSubjectBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateSubject(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelSubjectBtn" class="btn btn-tertiary" v-on:click.prevent="BackSubjectList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
  name: "SubjectCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Subject | " +process.env.COPYRIGHT_NAME : "Create Subject | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    code: "",
    name: "",
    loading:false,
    code_error_msg: "",
    name_error_msg: "",
    module_error_msg: "",
    moduleArr:[],
    modules:"",
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_comment_type') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['module']);
        setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");
            
            if (segments[3]) {
                self.loadSubject();
            }
        }, 100);

        // self.getModules();
  },
  methods: {
    BackSubjectList() {
      var self = this;
      self.$router.push("/subject/list");
    },
    

    CreateSubject(flag) {
      var self = this;

      self.code = self.code.trim();
      self.name = self.name.trim();

      self.code_error_msg = "";
      self.name_error_msg = "";
      self.module_error_msg = "";
      if(self.modules == null){
          self.modules = "";
      }

      if (!self.modules || self.modules == null || self.modules == "" || !self.modules.value || self.modules.value == '') {
        self.module_error_msg = "Module Required.";
      }
      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Type Required.";
      }

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
      }
      
      if (self.code_error_msg == "" && self.name_error_msg == "") {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateSubjectBtn").val("Updating ...");
                $("#CreateSubjectBtn").prop("disabled", true);
                $("#cancelSubjectBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueSubjectBtn").val("Saving ...");
                    $("#CreateSubjectBtn").prop("disabled", true);
                    $("#createAndContinueSubjectBtn").prop("disabled", true);
                    $("#cancelSubjectBtn").prop("disabled",true);

                }else{

                    $("#CreateSubjectBtn").val("Saving ...");
                    $("#CreateSubjectBtn").prop("disabled", true);
                    $("#createAndContinueSubjectBtn").prop("disabled", true);
                    $("#cancelSubjectBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/subject/create",
                type: "POST",
                data: {code: self.code, name: self.name,id: segments[3],module:self.modules.value},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateSubjectBtn").val("Update");
                        $("#CreateSubjectBtn").prop("disabled", false);
                        $("#cancelSubjectBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueSubjectBtn").val("Save and Continue");
                            $("#CreateSubjectBtn").prop("disabled", false);
                            $("#createAndContinueSubjectBtn").prop("disabled", false);
                            $("#cancelSubjectBtn").prop("disabled",false);

                        }else{

                            $("#CreateSubjectBtn").val("Save");
                            $("#CreateSubjectBtn").prop("disabled", false);
                            $("#createAndContinueSubjectBtn").prop("disabled", false);
                            $("#cancelSubjectBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#SubjectForm").trigger("reset");
                            self.code = "";
                            self.name ="";

                        }else{
                            self.$router.push("/subject/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateSubjectBtn").val("Update");
                        $("#CreateSubjectBtn").prop("disabled", false);
                        $("#cancelSubjectBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#SubjectForm").trigger("reset");
                            

                            $("#createAndContinueSubjectBtn").val("Save and Continue");
                            $("#CreateSubjectBtn").prop("disabled", false);
                            $("#createAndContinueSubjectBtn").prop("disabled", false);
                            $("#cancelSubjectBtn").prop("disabled",false);

                        }else{

                            $("#CreateSubjectBtn").val("Save");
                            $("#CreateSubjectBtn").prop("disabled", false);
                            $("#createAndContinueSubjectBtn").prop("disabled", false);
                            $("#cancelSubjectBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'reason-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }
     
    },

    loadSubject() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/subject/fetch/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    self.code = data.content.type;
                    self.name = data.content.name;
                    self.modules = {value:data.content.module,text:data.content.module_text};
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'reason-by-id')
            }
        });
    },
    
  }
};
</script>


// WEBPACK FOOTER //
// src/components/CommentTypeConfig.vue